import React from "react";
import "../../styles/Home.css";

const Home = () => (
  <div>
    <h1 className="title">Welcome</h1>
  </div>
);

export default Home;
